import { RootStateType } from '../rootReducer';

export const selectApp = (state: RootStateType) => state.app;

export const selectCurrentLocation = (state: RootStateType) => state.router.location;

export const selectLocationPath = (state: RootStateType) => state.router.location.pathname;

export const selectMenuItems = (state: RootStateType) => state.app.menu;
